import { Flex, Text } from '@chakra-ui/react';
import { FormikProps } from 'formik';
import { FormLabel } from 'ui-components';
import { Input } from 'ui-components/dist/Input';
import Button from '~/components/Button';
import { convertPxToRems } from '~/utils-ts';

interface FormValues {
  url: string;
}

interface Props {
  formik: FormikProps<FormValues>;
  isDisabled: boolean;
  isLoading: boolean;
  isLimitReached: boolean;
}

export const WebLinksForm: React.FC<Props> = ({
  formik,
  isDisabled,
  isLoading,
  isLimitReached,
}) => {
  const { errors, dirty, values, handleSubmit, resetForm, getFieldProps } =
    formik;

  return (
    <form onSubmit={handleSubmit}>
      {isLimitReached ? (
        <Text>You have reached the limit of 4 links.</Text>
      ) : (
        <>
          <FormLabel htmlFor="url">URL</FormLabel>
          <Flex minWidth="max-content" justifyContent="space-between" gap="2">
            <Input
              defaultValue={values.url}
              disableFormik
              error={errors.url && dirty ? errors.url : undefined}
              id="url"
              onClear={() => resetForm()}
              placeholder="Enter a URL"
              track-id="foam-web-links-url-input"
              {...getFieldProps('url')}
            />

            <Button
              aria-label="Add new link"
              type="submit"
              size="md"
              fontSize="md"
              width={convertPxToRems(74)}
              isDisabled={isDisabled}
              isLoading={isLoading}
              track-id="foam-web-links-add"
              sx={{
                marginTop: 1,
              }}
            >
              Add
            </Button>
          </Flex>
        </>
      )}
    </form>
  );
};
